module.exports = __webpack_public_path__ + "img/burger.343332d6.jpg";